import { createSlice } from "@reduxjs/toolkit";
import { ContentLibrarySlice, defaultContentLibraryFilters } from "types/campaign/content";
import { fetchContentLibraryThunk } from "./thunk";
import { ERROR } from "types";

const initialState: ContentLibrarySlice = {
    error: null,
    loading: true,
    applied_filter_id: null,
    filters: defaultContentLibraryFilters,
    total: 0,
    filtered_lists: {},
}

const contentLibrarySlice = createSlice({
    name: 'contentLibrary',
    initialState,
    reducers: {
        updateContentLibraryFilters: (state, { payload }) => {
            state.filters = payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchContentLibraryThunk.pending, (state) => {
                state.error = null;
                state.loading = true;
            })
            .addCase(fetchContentLibraryThunk.fulfilled, (state, { payload }) => {
                const { library, filters, filterId } = payload;
                state.loading = false;
                state.error = null;
                const existingData = state.filtered_lists?.[filterId]?.list;
                const list = filters.page === 1 ? library.items : [...existingData, ...library.items];
                state.filtered_lists = {
                    ...(state.filtered_lists ?? {}),
                    [filterId]: {
                        list,
                        page: filters.page,
                        expired: false,
                        last_fetched_at: Date.now(),
                        has_more: library.count > list.length,
                        filters: filters,
                        count: library.count
                    }
                }
                state.total = library.count;
                state.applied_filter_id = filterId;
            })
            .addCase(fetchContentLibraryThunk.rejected, (state, { payload }) => {
                state.loading = false;
                if (payload !== ERROR.CACHED)
                    state.error = payload || "Failed to fetch content library!"
            })
    }
})

export const { updateContentLibraryFilters } = contentLibrarySlice.actions;
export default contentLibrarySlice.reducer;